export enum TimeCardStatus {
  CLOCKED_IN = "CLOCKED_IN",
  BREAK = "BREAK",
  LUNCH = "LUNCH",
  CLOCKED_OUT = "CLOCKED_OUT",
}
